/**
 * @author gyb(mocheer)
 * @email mocheer@foxmail.com  
 * @since 2017.6.12
 */
import Tool from './Tool'
//
let { Rectangle } = L;
/**
 * 矩形绘制工具
 */
export default class RectTool extends Tool {
  options = { feature: { color: 'red', fillOpacity: .5, weight: 1 } }
  /**
   * 启动
   */
  start() {
    this.onMouseMove = this.onMouseMove.bind(this)
    this.onMouseDown = this.onMouseDown.bind(this)
    let { map } = this;
    map.once('mousedown', this.onMouseDown);
  }
  /**
   * 取消
   */
  cancel() {
    let { map } = this;
    map.off('mousedown', this.onMouseDown);
    map.off('mousemove', this.onMouseMove);
    this.sp = null;
  }
  /**
   * 绘制
   * @param e 
   */
  onMouseDown(e) {
    let { map, layer, options } = this;
    let { latlng } = e;
    this.clear();//重复绘制，先移除旧图元
    //
    this.marker = new Rectangle(L.latLngBounds(latlng, latlng), options.feature).addTo(layer)
    this.sp = latlng
    map.on('mousemove', this.onMouseMove);
    map.once('mouseup', this.onEnd.bind(this));
  }
  /**
   * 
   * @param e 
   */
  onMouseMove(e) {
    let { marker } = this;
    let { latlng } = e;
    marker.setBounds(L.latLngBounds(this.sp, latlng))
    marker.redraw();
  }
}


// WEBPACK FOOTER //
// ./src/plugins/tools/RectTool.js